export default "__VITE_ASSET__cIWDOj0W__";